import { gql } from 'graphql.macro';

export const deleteWebhookDeliveryTemplate = gql`
    mutation deleteWebhookDelivery($id: MongoDbObjectId!) {
        deleteWebhookDelivery(id: $id)
    }
`;
